import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Reports from '../components/reports/list'
import ExportsPage from '../components/reports/exports'
import ReportsTabs from '../components/reports/reportsTabs'

const ReportsRoute = (
  <Route path='reports'>
    <Route component={ReportsTabs}>
      <IndexRoute component={Reports} />
      <Route path='exports' component={ExportsPage} />
    </Route>
  </Route>
)

export default ReportsRoute
